export function lokiPhase(isPhaseOneEnabled: boolean, isPhaseTwoEnabled: boolean) {
  return isPhaseTwoEnabled ? 2 : isPhaseOneEnabled ? 1 : 0
}
